import { OnsiteInterview } from '~/actions/PermanentJobs';
import { IPermanentJobState, IOnsiteInterview } from './States';
import {
  TStoreOnsiteInterviewsAction,
  TDeleteOnsiteInterviewAction,
  TEditOnsiteInterviewAction,
  TClearOnsiteInterviewsAction,
  TPermanentJobAction,
} from './Types';
import { v4 } from 'uuid';
import { UserSubProfession } from '~/enums/UserProfession';

export const INITIAL_STATE: IPermanentJobState = {
  onsiteInterviews: {},
};

export default (
  state: IPermanentJobState = INITIAL_STATE,
  action: TPermanentJobAction,
): IPermanentJobState => {
  switch (action.type) {
    case OnsiteInterview.STORE: {
      const { payload } = action as TStoreOnsiteInterviewsAction;
      const { jobPostingId, data } = payload;

      const existingInterviews = state.onsiteInterviews[jobPostingId] || [];

      const newInterviews = data.dates.map((it) => {
        const isEFDA = data.profession === UserSubProfession.EFDA;

        return {
          breakTime: data.breakTime,
          date: it.toISOString(),
          hourlyRate: data.hourlyRate,
          hoursArrival: data.hoursArrival,
          hoursDeparture: data.hoursDeparture,
          isAssistedHygiene: data.isAssistedHygiene,
          id: v4(),
          isPaidBreakTime: data.isPaidBreakTime,
          profession: isEFDA
            ? (UserSubProfession.getProfession(data.profession) ?? data.profession)
            : data.profession,
          subProfession: isEFDA ? data.profession : undefined,
          specialty: data.specialty,
        } satisfies IOnsiteInterview;
      });

      const mergedInterviews = [...existingInterviews, ...newInterviews];

      return {
        ...state,
        onsiteInterviews: {
          ...state.onsiteInterviews,
          [jobPostingId]: mergedInterviews,
        },
      };
    }
    case OnsiteInterview.DELETE: {
      const { payload } = action as TDeleteOnsiteInterviewAction;
      const { id, jobPostingId } = payload;

      if (!state.onsiteInterviews[jobPostingId]) {
        return state;
      }

      const newInterviews = state.onsiteInterviews[jobPostingId].filter((it) => it.id !== id);

      return {
        ...state,
        onsiteInterviews: {
          ...state.onsiteInterviews,
          [jobPostingId]: newInterviews,
        },
      };
    }
    case OnsiteInterview.EDIT: {
      const { payload } = action as TEditOnsiteInterviewAction;
      const { postingId, onsiteInterview: data } = payload;

      if (!state.onsiteInterviews[postingId]) {
        return state;
      }

      const current = [...state.onsiteInterviews[postingId]];
      const idx = current.findIndex((it) => it.id === data.id);

      if (idx === -1) return state;

      current[idx] = {
        ...current[idx],
        breakTime: data.breakTime,
        hourlyRate: data.hourlyRate,
        hoursArrival: data.hoursArrival,
        hoursDeparture: data.hoursDeparture,
        isAssistedHygiene: data.isAssistedHygiene,
        isPaidBreakTime: data.isPaidBreakTime,
        specialty: data.specialty,
      } satisfies IOnsiteInterview;

      return {
        ...state,
        onsiteInterviews: {
          ...state.onsiteInterviews,
          [postingId]: current,
        },
      };
    }
    case OnsiteInterview.CLEAR: {
      const { payload } = action as TClearOnsiteInterviewsAction;
      const { postingId } = payload;

      return {
        ...state,
        onsiteInterviews: {
          ...state.onsiteInterviews,
          [postingId]: [],
        },
      };
    }
    default:
      return state;
  }
};
